import { useEffect, useState } from "react";

const createBG = (c) => `linear-gradient(${c[6]}deg, rgb(${c[0]},${c[1]},${c[2]}), rgb(${c[3]},${c[4]},${c[5]}))`;
const colorTrans = (before, after, dt) => {
    const delta = after - before;
    return before + delta * (dt / 3000);
};

const useSky = () => {
    const [day, setDay] = useState(0);
    const [bg, setBg] = useState('linear-gradient(to bottom, rgb(3,105,161), rgb(56,189,248))');
    const skyColor = [
        [56,189,248,3,105,161, 0],
        [194,65,12,251,146,60, -135],
        [8,4,54,6,3,69, 180],
        [7,89,133,245,158,11, 135]
    ];

    const nextTime = () => setDay((currentDay) => (currentDay + 1) % skyColor.length);

    const transitionBackground = (before, after) => {
        const duration = 3000;
        const startTime = performance.now();

        const step = (now) => {
            const elapsedTime = now - startTime;
            if (elapsedTime < duration) {
                const interpolatedColors = before.map((start, i) => colorTrans(start, after[i], elapsedTime));
                setBg(createBG(interpolatedColors));
                requestAnimationFrame(step);
            } else {
                setBg(createBG(after));
                nextTime();
            }
        };

        requestAnimationFrame(step);
    };

    useEffect(() => {
        if (day % 2 === 0) {
            setBg(createBG(skyColor[Math.floor(day / 2)]));
        } else {
            const currentColors = skyColor[Math.floor(day / 2)];
            const nextColors = skyColor[(Math.floor(day / 2) + 1) % skyColor.length];
            transitionBackground(currentColors, nextColors);
        }
    }, [day]);

    useEffect(() => {
        const interval = setInterval(nextTime, 15000);
        return () => clearInterval(interval);
    }, []);

    return { bg, day };
};

export default useSky;
